import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { setLocale } from "yup";

const mixed = defineMessages({
  default: {
    id: "yup.mixed.default",
    description: "",
    defaultMessage: "{labelOrPath} is invalid",
  },
  required: {
    id: "yup.mixed.required",
    description: "",
    defaultMessage: "{labelOrPath} is a required field",
  },
  oneOf: {
    id: "yup.mixed.oneOf",
    description: "",
    defaultMessage:
      "{labelOrPath} must be one of the following values: {values}",
  },
  notOneOf: {
    id: "yup.mixed.notOneOf",
    description: "",
    defaultMessage:
      "{labelOrPath} must not be one of the following values: {values}",
  },
  // notType: {
  //   id: "yup.mixed.notType",
  //   description: "",
  //   defaultMessage: ""
  // }
});

const string = defineMessages({
  length: {
    id: "yup.string.length",
    description: "",
    defaultMessage: "{labelOrPath} must be exactly {length} characters",
  },
  min: {
    id: "yup.string.min",
    description: "",
    defaultMessage: "{labelOrPath} must be at least {min} characters",
  },
  max: {
    id: "yup.string.max",
    description: "",
    defaultMessage: "{labelOrPath} must be at most {max} characters",
  },
  matches: {
    id: "yup.string.matches",
    description: "",
    defaultMessage: '{labelOrPath} must match the following: "{regex}"',
  },
  email: {
    id: "yup.string.email",
    description: "",
    defaultMessage: "{labelOrPath} must be a valid email",
  },
  url: {
    id: "yup.string.url",
    description: "",
    defaultMessage: "{labelOrPath} must be a valid URL",
  },
  trim: {
    id: "yup.string.trim",
    description: "",
    defaultMessage: "{labelOrPath} must be a trimmed string",
  },
  lowercase: {
    id: "yup.string.lowercase",
    description: "",
    defaultMessage: "{labelOrPath} must be a lowercase string",
  },
  uppercase: {
    id: "yup.string.uppercase",
    description: "",
    defaultMessage: "{labelOrPath} must be a upper case string",
  },
});

function YupLocaleSetup() {
  const { formatMessage: t } = useIntl();

  React.useEffect(() => {
    setLocale({
      mixed: {
        default: ({ label, path }) =>
          t(mixed.default, { labelOrPath: label ?? path }),
        required: ({ label, path }) =>
          t(mixed.required, { labelOrPath: label ?? path }),
        oneOf: ({ label, path, values }) =>
          t(mixed.oneOf, { labelOrPath: label ?? path, values }),
        notOneOf: ({ label, path, values }) =>
          t(mixed.notOneOf, { labelOrPath: label ?? path, values }),
        // notType: ({ path, type, value, originalValue }) =>
        //   t(mixed.notType, { path, type, value, originalValue })
      },
      string: {
        length: ({ label, path, length }) =>
          t(string.length, { labelOrPath: label ?? path, length }),
        min: ({ label, path, min }) =>
          t(string.min, { labelOrPath: label ?? path, min }),
        max: ({ label, path, max }) =>
          t(string.max, { labelOrPath: label ?? path, max }),
        matches: ({ label, path, regex }) =>
          t(string.matches, { labelOrPath: label ?? path, regex: `${regex}` }),
        email: ({ label, path }) =>
          t(string.email, { labelOrPath: label ?? path }),
        url: ({ label, path }) => t(string.url, { labelOrPath: label ?? path }),
        trim: ({ label, path }) =>
          t(string.trim, { labelOrPath: label ?? path }),
        lowercase: ({ label, path }) =>
          t(string.lowercase, { labelOrPath: label ?? path }),
        uppercase: ({ label, path }) =>
          t(string.uppercase, { labelOrPath: label ?? path }),
      },
    });
  }, [t]);

  return null;
}

export default YupLocaleSetup;
